import { render, staticRenderFns } from "./SizeSelection.vue?vue&type=template&id=b07e82d4&scoped=true&"
import script from "./SizeSelection.vue?vue&type=script&lang=ts&"
export * from "./SizeSelection.vue?vue&type=script&lang=ts&"
import style0 from "./SizeSelection.vue?vue&type=style&index=0&id=b07e82d4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07e82d4",
  null
  
)

export default component.exports